import store from '@state/store'
import layout from '@layouts/main'

const emptyComponent = {
  render(h) {
    return h('router-view')
  },
}

export default [
  {
    path: '/',
    redirect: {
      name: 'admin-index',
    },
  },
  {
    path: '/brokerage-console/:brokerage_seq',
    component: emptyComponent,
    meta: {
      authRequired: true,
    },
    redirect: {
      name: 'brokerage-console-index',
    },
    children: [
      {
        name: 'brokerage-console-index',
        path: 'index',
        component: () => lazyLoadView(import('@views/brokerage-console/index')),
      },
      {
        name: 'brokerage-console-relation-list',
        path: 'relation/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/relation-list')),
      },
      {
        name: 'brokerage-console-member-list',
        path: 'member/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/member-list')),
      },
      {
        name: 'brokerage-console-pg-merchant-list',
        path: 'pg-merchant/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/pg-merchant-list')),
      },
      {
        name: 'brokerage-console-share-list',
        path: 'share/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/share-list')),
      },
      {
        name: 'brokerage-console-child-list',
        path: 'child/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/child-list')),
      },
      {
        name: 'brokerage-console-child-view',
        path: 'child/:child_seq/view',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/child-view')),
      },
      {
        name: 'brokerage-console-balance-list',
        path: 'balance/list',
        component: () =>
          lazyLoadView(import('@views/brokerage-console/balance-list')),
      },
      {
        name: 'brokerage-console-outsite-transaction-list',
        path: 'outsite-transaction/list',
        component: () =>
          lazyLoadView(
            import('@views/brokerage-console/outsite-transaction-list')
          ),
      },
    ],
    beforeEnter(to, from, next) {
      store
        .dispatch('brokerage/getBrokerages')
        .then(() =>
          store.dispatch('brokerage/selectBrokerage', to.params.brokerage_seq)
        )
        .then(() => {
          if (store.getters['brokerage/brokerage_info']) {
            return next()
          } else {
            return next({
              name: 'login-me',
              query: { dashboard_type: 'brokerage' },
            })
          }
        })
    },
  },
  {
    path: '/admin',
    component: emptyComponent,
    meta: {
      authRequired: true,
    },
    redirect: {
      name: 'admin-index',
    },
    children: [
      {
        name: 'admin-index',
        path: 'index',
        component: () => lazyLoadView(import('@views/admin/index')),
      },
      {
        path: 'member/list',
        name: 'admin-member-list',
        component: () => lazyLoadView(import('@views/admin/member-list')),
      },
      {
        path: 'member/group/list',
        name: 'admin-member-group-list',
        component: () => lazyLoadView(import('@views/admin/member-group-list')),
      },
      {
        path: 'account/list',
        name: 'admin-account-list',
        component: () => lazyLoadView(import('@views/admin/account-list')),
      },
      {
        path: 'account/update-balance-bulk',
        name: 'admin-account-update-balance-bulk',
        component: () =>
          lazyLoadView(import('@views/admin/account-update-balance-bulk')),
      },
      {
        path: 'deposit/list',
        name: 'admin-deposit-list',
        component: () => lazyLoadView(import('@views/admin/deposit-list')),
      },
      {
        path: 'withdraw/list',
        name: 'admin-withdraw-list',
        component: () => lazyLoadView(import('@views/admin/withdraw-list')),
      },
      {
        path: 'account-transfer/list',
        name: 'admin-account-transfer-list',
        component: () =>
          lazyLoadView(import('@views/admin/account-transfer-list')),
      },
      {
        path: 'withdraw-transfer/list',
        name: 'admin-withdraw-transfer-list',
        component: () =>
          lazyLoadView(import('@views/admin/withdraw-transfer-list')),
      },
      {
        path: 'withdraw/policy',
        name: 'admin-withdraw-policy',
        component: () => lazyLoadView(import('@views/admin/withdraw-policy')),
      },
      {
        path: 'kyc-certification/list',
        name: 'admin-kyc-certification-list',
        component: () =>
          lazyLoadView(import('@views/admin/kyc-certification-list')),
      },
      {
        path: 'kyc-realname/list',
        name: 'admin-kyc-realname-list',
        component: () => lazyLoadView(import('@views/admin/kyc-realname-list')),
      },
      {
        path: 'kyc-asset-withdraw-address-certification/list',
        name: 'admin-kyc-asset-withdraw-address-certification-list',
        component: () =>
          lazyLoadView(
            import('@views/admin/kyc-asset-withdraw-address-certification-list')
          ),
      },
      {
        path: 'direct-transfer/list',
        name: 'admin-direct-transfer-list',
        component: () =>
          lazyLoadView(import('@views/admin/direct-transfer-list')),
      },
      {
        path: 'private-application/list',
        name: 'admin-private-application-list',
        component: () =>
          lazyLoadView(import('@views/admin/private-application-list')),
      },
      {
        path: 'private-deal/list',
        name: 'admin-private-deal-list',
        component: () => lazyLoadView(import('@views/admin/private-deal-list')),
      },
      {
        path: 'loginlog/list',
        name: 'admin-loginlog-list',
        component: () => lazyLoadView(import('@views/admin/loginlog-list')),
      },
      {
        path: 'oauth2-client/list',
        name: 'admin-oauth2-client-list',
        component: () =>
          lazyLoadView(import('@views/admin/oauth2-client-list')),
      },
      {
        path: 'activity-log/list',
        name: 'admin-activity-log-list',
        component: () => lazyLoadView(import('@views/admin/activity-log-list')),
      },
      {
        path: 'market/catalog',
        name: 'admin-market',
        component: () => lazyLoadView(import('@views/admin/market')),
      },
      {
        path: 'asset/list',
        name: 'admin-asset-list',
        component: () => lazyLoadView(import('@views/admin/asset-list')),
      },
      {
        path: 'asset-plugin/list',
        name: 'admin-asset-plugin-list',
        component: () => lazyLoadView(import('@views/admin/asset-plugin-list')),
      },
      {
        path: 'security/catalog',
        name: 'admin-security',
        component: () => lazyLoadView(import('@views/admin/security-level')),
      },
      {
        path: 'member/:member_seq/view',
        name: 'admin-member-catalog',
        component: () => lazyLoadView(import('@views/admin/member-view')),
      },
      {
        path: 'member/:member_seq/account',
        name: 'admin-member-account-list',
        component: () =>
          lazyLoadView(import('@views/admin/member-account-list')),
      },
      {
        path: 'member/:member_seq/loginlog',
        name: 'admin-member-loginlog-list',
        component: () =>
          lazyLoadView(import('@views/admin/member-loginlog-list')),
      },
      {
        path: 'member/:member_seq/oauth2-client',
        name: 'admin-member-oauth2-client-list',
        component: () =>
          lazyLoadView(import('@views/admin/member-oauth2-client-list')),
      },
      {
        path: 'member/:member_seq/invite-relation',
        name: 'admin-member-invite-relation-list',
        component: () =>
          lazyLoadView(import('@views/admin/member-invite-relation-list')),
      },
      {
        path: 'account/:account_seq/view',
        name: 'admin-account-catalog',
        component: () => lazyLoadView(import('@views/admin/account-view')),
      },
      {
        path: 'account/:account_seq/balance-log',
        name: 'admin-account-balance-log-list',
        component: () =>
          lazyLoadView(import('@views/admin/account-balance-log-list')),
      },
      {
        path: 'lang',
        name: 'admin-lang-list',
        component: () => lazyLoadView(import('@views/admin/lang-list')),
      },
      {
        path: 'acs/catalog',
        name: 'admin-acs-catalog',
        component: () => lazyLoadView(import('@views/admin/acs-catalog')),
      },
      {
        path: 'finance/catalog',
        name: 'admin-finance-catalog',
        component: () => lazyLoadView(import('@views/admin/finance-catalog')),
      },
      {
        path: 'finance/fund-list',
        name: 'admin-finance-fund-list',
        component: () => lazyLoadView(import('@views/admin/finance-fund-list')),
      },
      {
        path: 'finance/return-list',
        name: 'admin-finance-return-list',
        component: () =>
          lazyLoadView(import('@views/admin/finance-return-list')),
      },
      {
        path: 'finance/dividend-list',
        name: 'admin-finance-dividend-list',
        component: () =>
          lazyLoadView(import('@views/admin/finance-dividend-list')),
      },
      {
        path: 'contract/catalog',
        name: 'admin-contract-catalog',
        component: () => lazyLoadView(import('@views/admin/contract-catalog')),
      },
      {
        path: 'contract/agreement-list',
        name: 'admin-contract-agreement-list',
        component: () =>
          lazyLoadView(import('@views/admin/contract-agreement-list')),
      },
      {
        path: 'cs/ticket/list',
        name: 'admin-cs-ticket-list',
        component: () => lazyLoadView(import('@views/admin/cs-ticket-list')),
      },
      {
        path: 'cs/faq/list',
        name: 'admin-cs-faq-list',
        component: () => lazyLoadView(import('@views/admin/cs-faq-list')),
      },
      {
        path: 'affiliate/policy',
        name: 'admin-affiliate-policy',
        component: () => lazyLoadView(import('@views/admin/affiliate-policy')),
      },
      {
        path: 'affiliate/log-list',
        name: 'admin-affiliate-log-list',
        component: () =>
          lazyLoadView(import('@views/admin/affiliate-log-list')),
      },
      {
        path: 'affiliate/balance-list',
        name: 'admin-affiliate-balance-list',
        component: () =>
          lazyLoadView(import('@views/admin/affiliate-balance-list')),
      },
      {
        path: 'affiliate/adjust-list',
        name: 'admin-affiliate-adjust-list',
        component: () =>
          lazyLoadView(import('@views/admin/affiliate-adjust-list')),
      },
      {
        path: 'pg/merchant-list',
        name: 'admin-pg-merchant-list',
        component: () => lazyLoadView(import('@views/admin/pg-merchant-list')),
      },
      {
        path: 'pg/merchant/:merchant_seq/view',
        name: 'admin-pg-merchant-catalog',
        component: () => lazyLoadView(import('@views/admin/pg-merchant-view')),
      },
      {
        path: 'pg/feeset',
        name: 'admin-pg-feeset',
        component: () => lazyLoadView(import('@views/admin/pg-feeset')),
      },
      {
        path: 'pg/transaction-list',
        name: 'admin-pg-transaction-list',
        component: () =>
          lazyLoadView(import('@views/admin/pg-transaction-list')),
      },
      {
        path: 'brokerage/list',
        name: 'admin-brokerage-list',
        component: () => lazyLoadView(import('@views/admin/brokerage-list')),
      },
      {
        path: 'brokerage/balance-list',
        name: 'admin-brokerage-balance-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-balance-list')),
      },
      {
        path: 'brokerage/share-list',
        name: 'admin-brokerage-share-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-share-list')),
      },
      {
        path: 'brokerage/adjust-list',
        name: 'admin-brokerage-adjust-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-adjust-list')),
      },
      {
        path: 'brokerage/:brokerage_seq/view',
        name: 'admin-brokerage-catalog',
        component: () => lazyLoadView(import('@views/admin/brokerage-view')),
      },
      {
        path: 'brokerage/:brokerage_seq/relation-list',
        name: 'admin-brokerage-catalog-relation-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-catalog-relation-list')),
      },
      {
        path: 'brokerage/:brokerage_seq/balance-list',
        name: 'admin-brokerage-catalog-balance-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-catalog-balance-list')),
      },
      {
        path: 'brokerage/:brokerage_seq/share-list',
        name: 'admin-brokerage-catalog-share-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-catalog-share-list')),
      },
      {
        path: 'brokerage/:brokerage_seq/adjust-list',
        name: 'admin-brokerage-catalog-adjust-list',
        component: () =>
          lazyLoadView(import('@views/admin/brokerage-catalog-adjust-list')),
      },
      {
        path: 'statistic',
        name: 'admin-statistic',
        component: () => lazyLoadView(import('@views/admin/statistic')),
      },
      {
        path: 'public/order-list',
        name: 'admin-public-order-list',
        component: () => lazyLoadView(import('@views/admin/public-order-list')),
      },
      {
        path: 'public/trade-list',
        name: 'admin-public-trade-list',
        component: () => lazyLoadView(import('@views/admin/public-trade-list')),
      },
      {
        path: 'public/balance-transfer-list',
        name: 'admin-public-balance-transfer-list',
        component: () =>
          lazyLoadView(import('@views/admin/public-balance-transfer-list')),
      },
      {
        path: 'config',
        component: emptyComponent,
        children: [
          {
            name: 'admin-config-member',
            path: 'member',
            component: () => lazyLoadView(import('@views/admin/config-member')),
          },
          {
            name: 'admin-config-service',
            path: 'service',
            component: () =>
              lazyLoadView(import('@views/admin/config-service')),
          },
          {
            name: 'admin-config-kyc',
            path: 'kyc',
            component: () => lazyLoadView(import('@views/admin/config-kyc')),
          },
          {
            name: 'admin-config-mail',
            path: 'mail',
            component: () => lazyLoadView(import('@views/admin/config-mail')),
          },
          {
            name: 'admin-config-phone',
            path: 'phone',
            component: () => lazyLoadView(import('@views/admin/config-phone')),
          },
          {
            name: 'admin-config-otp',
            path: 'otp',
            component: () => lazyLoadView(import('@views/admin/config-otp')),
          },
          {
            name: 'admin-config-notification',
            path: 'notification',
            component: () =>
              lazyLoadView(import('@views/admin/config-notification')),
          },
          {
            name: 'admin-config-cs',
            path: 'cs',
            component: () => lazyLoadView(import('@views/admin/config-cs')),
          },
        ],
      },
    ],
  },
  {
    path: '/',
    component: layout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => lazyLoadView(import('@views/login')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
              // Redirect to the home page instead
              next({
                name: 'home',
              })
            } else {
              // Continue to the login page
              next()
            }
          },
        },
      },
      {
        path: '/login-me',
        name: 'login-me',
        component: () => lazyLoadView(import('@views/login-me')),
      },
      {
        path: '/register',
        name: 'register',
        component: () => lazyLoadView(import('@views/register')),
      },
      {
        path: '/find',
        name: 'account-find',
        component: () => lazyLoadView(import('@views/account-find')),
      },
      {
        path: '/logout',
        name: 'logout',
        meta: {
          authRequired: true,
          beforeResolve(routeTo, routeFrom, next) {
            store.dispatch('auth/logOut')
            const authRequiredOnPreviousRoute = routeFrom.matched.some(
              (route) => route.meta.authRequired
            )
            // Navigate back to previous page, or home as a fallback
            next(
              authRequiredOnPreviousRoute
                ? {
                    name: 'login-me',
                  }
                : {
                    ...routeFrom,
                  }
            )
          },
        },
      },
    ],
  },

  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
